import getBasePath from '../functions/api-resource';
import empresa from '../functions/company';

const basePath = getBasePath('api', 'auth');

const usuarioActions = {
    logIn: { method: 'Post', url: `${basePath}/login?conexion=${empresa}` },
    validacion: { method: 'GET', url: `${basePath}/personal/validacionStshop?conexion=${empresa}` },


};

export default resource => resource(`${basePath}`, {}, usuarioActions);


// WEBPACK FOOTER //
// ./src/common/resources/usuario.js